import parentPlatforms from './reducers';

import * as parentPlatformOperations from './operations';
import retailerTypes from './types';

export { retailerTypes, parentPlatformOperations };

export default parentPlatforms;
